const syncUTMsToCart = () => {
  if (!window.URLParametersTracking) return;

  const { utm_source = '', utm_medium = '', utm_campaign = '', klar_source = '' } = window.URLParametersTracking.getStorage();

  if (!utm_source && !utm_medium && !utm_campaign && !klar_source) return;

  fetch(`${window.Shopify.routes.root}cart/update.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      attributes: { utm_source, utm_medium, utm_campaign, klar_source }
    })
  }).catch((err) => console.warn('UTM cart sync failed:', err));
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', syncUTMsToCart);
} else {
  syncUTMsToCart();
}
